module.exports = __webpack_public_path__ + "static/media/banner-navidad-brios-web.08ce8af9.webp";